<!--================================
=            DASHBOARD1            =
=================================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Dashboard1</div>
      </base-header>
    </v-row>

    <v-row>


      <v-col cols="12" md="8" sm="12">
        <base-card>
          <div slot="card-header">

            <v-row >
              <v-col cols="12" sm="6">
                <v-card-title class="ml-n4 font-weight-black">
                  Welcome Back!!
                </v-card-title>

                <v-card-subtitle class="ml-n4 ">
                  You have completed 76% of your goal this week!

                </v-card-subtitle>
                <v-card-subtitle class="ml-n4  mt-n8">

                  Start a new goal and improve your result.
                </v-card-subtitle>
              </v-col>
              <v-col cols="12" sm="6">
                <apex-semi-domut></apex-semi-domut>
              </v-col>
            </v-row>
          </div>

        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">
            <v-list-item class="ml-n4 " three-line>
              <v-list-item-content>
                <div class="text-overline white--text mb-4">
                  BITCOIN
                </div>
                <v-list-item-title class="text-h5 font-weight-black  white--text mb-1">
                  0.15%
                  <v-icon large color="orange darken-2">
                    mdi-arrow-up-bold-box-outline
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">$ 39.458</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" color="transparent">
                <v-img src="../../assets/images/coin/btc.png" alt="Sunny image" width="102"></v-img>
              </v-list-item-avatar>
            </v-list-item>

          </div>

          <div slot="card-body">






          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Anual Trades
          </div>
          <div slot="card-subheader">Minim do incididunt et sit. </div>
          <div slot="card-body">
            <echarts-column></echarts-column>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            To life today
          </div>
          <div slot="card-subheader">Minim do incididunt et sit. </div>
          <div slot="card-body">
            <v-list subheader class="ml-n4" color="transparent" dark two-line>


              <v-list-item v-for="folder in list2" :key="folder.title">
                <v-list-item-avatar class="rounded-lg " :color="folder.color" size="50">
                  <v-icon size="40" dark>{{folder.icon}}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class=" subtitle-1 font-weight-bold" v-text="folder.title">
                  </v-list-item-title>

                  <v-list-item-subtitle v-text="folder.subtitle"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-switch v-model="folder.switch1" inset></v-switch>

                </v-list-item-action>
              </v-list-item>



            </v-list>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Exchange Portfolio
          </div>
          <div slot="card-subheader">Minim do incididunt et sit. </div>
          <div slot="card-body">
            <echarts-pie></echarts-pie>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">
            <div class="text-h5 font-weight-black white--text mb-1">
              56%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              1 Hours
            </div>

          </div>
          <div slot="card-subheader">Minim do incididunt et sit. </div>
          <div slot="card-body">
            <v-sheet color="primary" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>


          </div>
        </base-card>
      </v-col>

      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">
            <div class="text-h5 font-weight-black white--text mb-1">
              16%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              Last 24h
            </div>

          </div>
          <div slot="card-subheader">Minim do incididunt et sit. </div>
          <div slot="card-body">
            <v-sheet color="primary ligthen-3" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>


          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">
            <div class="text-h5 font-weight-black white--text mb-1">
              96%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              30 days
            </div>

          </div>
          <div slot="card-subheader">Minim do incididunt et sit. </div>
          <div slot="card-body">
            <v-sheet color="primary ligthen-3" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>

          </div>
        </base-card>
      </v-col>


    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader';
  import EchartsColumn from '../../components/Charts/EchartsColumn.vue'
  import EchartsPie from '../../components/Charts/EchartsPie'
  import ApexSemiDomut from '../../components/Charts/ApexSemiDomut'
  export default {
    components: {
      BaseCard,
      BaseHeader,
      EchartsColumn,
      EchartsPie,
      ApexSemiDomut
    },
    data() {
      return {
        toggle_exclusive: 2,
        rating: 5,
        labels: [
          '12am',
          '3am',
          '6am',
          '9am',
          '12pm',
          '3pm',
          '6pm',
          '9pm',
        ],
        value: [
          200,
          675,
          410,
          390,
          310,
          460,
          250,
          240,
        ],
        list1: [{
            color: 'primary',
            icon: 'home',
            subtitle: 'Active',
            title: 'Organize to my life',
            switch1: false
          },
          {
            color: 'primary',
            icon: 'headset_mic',
            subtitle: 'Active',
            title: 'Podcast',
            switch1: true

          },
        ],
        list2: [{
            color: 'primary',
            icon: 'work_outline',
            subtitle: 'Active',
            title: 'Home Office',
            switch1: true

          },
          {
            color: 'primary',
            icon: 'monetization_on',
            subtitle: 'Active',
            title: 'Responsibility',
            switch1: true

          },
          {
            color: 'primary',
            icon: 'support',
            subtitle: 'Active',
            title: 'Forum Religion',
            switch1: false

          },

        ],
      }
    },


  }
</script>


<!--====  End of DASHBOARD1  ====-->